class SubCollectionLoad extends HTMLElement {
  constructor() {
    super()

    setTimeout(() => {
      this.activeFacets = document.querySelectorAll('.active-facets__button-inner')
      this.checkForActiveFacets()
    }, 0)

    this.watchForMutations()

  }

  checkForActiveFacets() {

    const updatedFacets = document.querySelectorAll('.active-facets__button-inner');
    // Remove selected class from all sub-collection items
    const subCollectionItems = document.querySelectorAll('.sub-collection__item');
    subCollectionItems.forEach(item => {
      item.classList.remove('sub-collection__item--selected');
    })

    if (updatedFacets.length > 0) {
      updatedFacets.forEach(facet => {
        let facetValue = facet.textContent.trim(); // Trim whitespace
        const modifiedFacetValue = facetValue.includes('Type:') ? facetValue.replace('Type:', '').trim() : facetValue;
        const modifiedFacetValueRm = modifiedFacetValue.replace('Remove filter', '').trim();
  
        const element = document.querySelector(`[data-value="${modifiedFacetValueRm}"]`);
        if (element) {
          const subCollectionItem = element.querySelector('.sub-collection__item');
          if (subCollectionItem) {
            subCollectionItem.classList.add('sub-collection__item--selected');
          }
        }
      });
    }
  }

  watchForMutations() {
    // Select the target node (sub-collections-container)
    const targetNode = document.querySelector('.active-facets');

    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            this.checkForActiveFacets()
          }
        }
      });

      const config = {
        attributes: true,        
        childList: true,         
        subtree: true
      };

      observer.observe(targetNode, config);

      // Optionally, you can stop observing later with:
      // observer.disconnect();
    } else {
      console.log('Target node not found.');
    }
  }

}

customElements.define('sub-collection-load', SubCollectionLoad)
